import { Dispatch, RefObject, SetStateAction } from 'react'

export const handleSlideChange =
  (
    index: number,
    itemsLength: number,
    containerRef: RefObject<HTMLDivElement>
  ) =>
  () => {
    let newIndex
    if (index < 0) {
      newIndex = itemsLength - 1
    } else if (index >= itemsLength) {
      newIndex = 0
    } else {
      newIndex = index
    }

    if (containerRef.current) {
      containerRef.current.scrollLeft =
        containerRef.current.clientWidth * newIndex
    }

    return newIndex
  }

export const handleScroll = (
  containerRef: RefObject<HTMLDivElement>,
  setCurrentIndex: Dispatch<SetStateAction<number>>
) => {
  if (containerRef.current) {
    const index = Math.round(
      containerRef.current.scrollLeft / containerRef.current.clientWidth
    )
    setCurrentIndex(index)
  }
}
